<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col md="10">
            <h3>Lista de E-mails</h3>
          </b-col>
          <b-col md="2">
            <b-button @click="navigate('/mensagem/cadastrar')" block variant="primary">
              <i class="fa fa-plus"></i>
              <span>Novo E-mail</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col sm="3">
            <b-form-group label="Nome ou CNPJ da Instituição:">
              <b-form-input type="text" id="name" v-model="filtros.filter" placeholder="Nome ou CNPJ"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="2">
            <b-form-group label="UF:">
              <b-form-select v-model="filtros.uf_id" :options="estados" class="mb-3">
                <option selected :value="null"> Selecione</option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="3">
            <b-form-group label="Município:" :disabled="disabled_cidades">
              <b-form-select v-model="filtros.municipio_id" :options="cidades">
                <option selected :value="null"> Selecione</option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="3">
            <b-form-group label="Nome ou CPF (Gestor/Tutor):">
              <b-form-input type="text" id="name" v-model="filtros.gestor" placeholder="Nome ou CPF"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="2">
            <b-form-group>
              <b-form-group label="Tipo de Envio:">
                <b-form-select v-model="filtros.tp_envio" class="mb-3">
                  <option selected :value="null"> Selecione</option>
                  <option v-for="item in tiposEnvio" :key="item.value" :value="item.value"> {{item.text}}</option>
                </b-form-select>
              </b-form-group>
            </b-form-group>
          </b-col>
          <b-col sm="2">
            <b-form-group>
              <b-form-group label="Data Início:">
                <b-form-input type="date" id="name" v-model="filtros.dt_inicio" placeholder="Data"></b-form-input>
              </b-form-group>
            </b-form-group>
          </b-col>
          <b-col sm="2">
            <b-form-group>
              <b-form-group label="Data Fim:">
                <b-form-input type="date" id="name" v-model="filtros.dt_fim" placeholder="Data"></b-form-input>
              </b-form-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2">
            <b-button @click="limpafiltro" block variant="cinza">
              <i class="fa fa-eraser"></i>
              <span>Limpar filtros</span>
            </b-button>
          </b-col>
          <b-col md="2">
            <b-button @click="pesquisar" block variant="primary">
              <i class="fa fa-search"></i>
              <span>Pesquisar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
      <b-row>
        <b-col sm="12">
          <b-container fluid>
            <span>
              <b-form-select style="width: 100px; float: right" class="mb-3" v-model="totalPorPagina"
                :options="totalSelectOp"></b-form-select>
              <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7"
                class="table table-responsive-sm table-bordered table-striped table-sm">
                <thead class="text-center">
                  <tr>
                    <th scope="col">Registro</th>
                    <th scope="col">Data de Envio</th>
                    <th scope="col">Assunto do E-mail</th>
                    <th scope="col">Tipo de envio</th>
                    <th scope="col">Situação</th>
                    <th scope="col">Ações</th>
                  </tr>
                </thead>
                <tbody v-if="mensagens.data !== undefined" class="text-center">
                  <tr v-for="mensagem in mensagens.data" :key="mensagem.id">
                    <td>{{mensagem.id}}</td>
                    <td>{{mensagem.created_at | formatDateToBR}}</td>
                    <td>{{mensagem.assunto}}</td>
                    <td>{{mensagem.model_tp_envios}}</td>
                    <td>{{mensagem.situacao}}</td>
                    <td style="width: 15%">
                      <a class="btn btn-sm btn-secondary action" title="Editar Mensagem" @click="editar(mensagem.id)">
                        <i class="fa fa-pencil-square-o"></i>
                      </a>
                      <a class="btn btn-sm btn-secondary action" title="Visualizar" @click="visualizar(mensagem.id)">
                        <i class="fa fa-eye"></i>
                      </a>
                      <a class="btn btn-sm btn-secondary action" title="Reencaminhar"
                        @click="reencaminhar(mensagem.id)">
                        <i class="fa fa-arrow-circle-right"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="action">
                    <td colspan="6">Nenhum registro de mensagem...</td>
                  </tr>
                </tbody>
              </table>
              <pagination v-show="mensagens.data !== undefined" :totalPorPagina="totalPorPagina" :resource="resource"
                :filtros="filtros"></pagination>
            </span>
          </b-container>
        </b-col>
      </b-row>
    </b-card>
  </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import { eventType } from '@/components/shared/eventType'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

export default {
  components: {
    Pagination
  },
  created () {
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'A') {
      this.$store.dispatch('getAdministradores')
      this.$store.dispatch('buscarEstados')
    } else {
      this.$router.push('/')
    }
  },
  data () {
    return {
      mainProps: { width: 250, height: 250 },
      disabled_cidades: true,
      videoSimular: '',
      respostaFinal: false,
      countadorErros: 0,
      tentativas: 1,
      respostaErrada: false,
      respostaCerta: false,
      modalSimular: false,
      totalPorPagina: 20,
      totalSelectOp: [
        { text: '20', value: 20 },
        { text: '30', value: 30 },
        { text: '50', value: 50 },
        { text: '100', value: 100 }
      ],
      resource: 'mensagens',
      filtros: {
        filter: '',
        uf_id: null,
        municipio_id: null,
        gestor: null,
        dt_inicio: null,
        dt_fim: null,
        tp_envio: null
      },
      tiposEnvio: [
        { value: 1, text: 'Instituição' },
        { value: 2, text: 'Gestor' },
        { value: 3, text: 'Tutor' }
      ]
    }
  },
  computed: {
    administradores () {
      return this.$store.state.usuario.administradores
    },
    mensagens () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    estados () {
      return this.$store.state.estado.listaEstados
    },
    cidades () {
      return this.$store.state.cidade.listaCidadesPorEstado
    }
  },
  watch: {
    'filtros.uf_id': function () {
      if (this.filtros.uf_id !== null) {
        this.$store.dispatch('buscarCidadesPorEstado', this.filtros.uf_id)
        this.disabled_cidades = false
      } else {
        this.disabled_cidades = true
        this.filtros.municipio_id = null
      }
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    pesquisar () {
      if (this.filtros.dt_inicio !== null && this.filtros.dt_fim !== null) {
        var date1 = new Date(this.filtros.dt_inicio)
        var date2 = new Date(this.filtros.dt_fim)

        var timeDiff = (date2.getTime() - date1.getTime())
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))
        if (diffDays < 1) {
          this.erro('Data de início deve ser menor que o final!')
          return false
        }
      }
      this.$store.dispatch('getRegistrosSearch', {
        resource: this.resource,
        limit: this.totalPorPagina,
        filtros: this.filtros
      })
      this.setarFiltros(this.filtros)
    },
    limpafiltro () {
      this.filtros = {
        filter: '',
        uf_id: null,
        municipio_id: null,
        gestor: null,
        dt_inicio: null,
        dt_fim: null,
        tp_envio: null
      }
      this.pesquisar()
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    editar (id) {
      this.$router.push('/mensagem/editar/' + id)
    },
    reencaminhar (id) {
      this.$router.push('/mensagem/reencaminhar/' + id)
    },
    visualizar (id) {
      this.$router.push('/mensagem/visualizar/' + id)
    },
    excluir (id) {
      this.$bvModal.msgBoxConfirm('Deseja realmente excluir essa mensagem?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.delete('api/mensagens/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            }
          }).catch(erro => {
            if (!erro.body.success) {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-check' })
              miniToastr.error(erro.body.msg, 'Alerta!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            }
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    navigate (route) {
      this.$router.push(route)
    },
    erro (msg) {
      miniToastr.setIcon('error', 'i', { 'class': 'fa fa-check' })
      miniToastr.error(msg, 'Alerta!', 5000)
    }
  }
}
</script>

<style scoped>
.action {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/mensages/Mensages.vue